// src/features/dashboard/services/Manager/associateRegister.service.ts

import api from '../../../../api/apiService';
import { ENDPOINTS } from '../../../../api/endpoints';

import {
  AssociateRegisterRequest,
  AssociateRiskResponse,
} from '../../types/Manager/atRiskAssociates.types';

// ======================================
// Get Associate Register
// ======================================

export const getAtRiskAssociateRegister = async (
  request: AssociateRegisterRequest
): Promise<AssociateRiskResponse[]> => {

  const payload: AssociateRegisterRequest = {
    managerEmployeeCode: request.managerEmployeeCode,
    fromDate: request.fromDate,
    toDate: request.toDate,
    productivityThreshold: request.productivityThreshold,
    noOfDays: request.noOfDays,
    idleThreshold: request.idleThreshold,
    activeHoursThreshold: request.activeHoursThreshold,
    nonProdThreshold: request.nonProdThreshold,
    attendanceThreshold: request.attendanceThreshold,
  };

  console.log('==============================');
  console.log('Associate Register Request');
  console.log(payload);
  console.log('==============================');

  try {
    const { data } = await api.post<AssociateRiskResponse[]>(
      ENDPOINTS.RISK_ASSOCIATE_REGISTER,
      payload
    );

    return data;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      console.warn(
        'Associate Register API returned 404. Returning empty array.'
      );

      return [];
    }

    console.error('Associate Register API Error:', error);
    throw error;
  }
};